class ContentEventsList {
  constructor(resource, api, options) {
    this.el = jQuery('<div class="content-events-container"><div class="content-events"></div></div>');
    this.options = jQuery.extend(
      {
        content_type: resource.baseType,
        content_id: resource.id,
        api: api,
      },
      options,
    );
    this.loadMoreButton = jQuery(
      '<div class="btn-group btn-group--large btn-group--justify-start"><button class="btn-group__chip btn-group__chip--icon-at-start"><sp-icon name="add"></sp-icon><span class="btn-group__chip-text">Load More</span></button></div>',
    );
    this.defaultPage = 1;
    this.nextPage;
  }

  reload() {
    this.el.find(".content-events").empty();
    this.nextPage = this.defaultPage;
    this.getContentEvents();
  }

  updateContentEvent(id, content_event) {
    this.el.find("#" + id).replaceWith(content_event);
    this.contrastDetection();
  }

  addLoadMore() {
    this.el.append(this.loadMoreButton);
    this.handleDataLoadingState(true);

    this.loadMoreButton.on("click", () => {
      this.getContentEvents(this.nextPage, false);
    });
  }

  getContentEvents(page, shouldPrepend) {
    var currentPage = page || this.defaultPage;
    let params = jQuery.extend({ page: currentPage }, this.options);
    this.handleDataLoadingState(false);

    return jQuery.get("/admin/content_events.json", params).then((data) => {
      this.nextPage = currentPage + 1;
      var contentEvents = jQuery("<div></div>").append(data.content_events);

      this.formatTimes(contentEvents);
      this.contrastDetection(contentEvents);

      if (shouldPrepend) {
        this.el.find(".content-events").prepend(contentEvents.children());
      } else {
        this.el.find(".content-events").append(contentEvents.children());
      }

      if (data.page_count < this.nextPage) {
        this.loadMoreButton.hide();
      }

      this.handleDataLoadingState(true);
    });
  }

  setDataLoadingStateClasses(fullfilled) {
    this.el.toggleClass(`--state-fullfilled`, fullfilled);
    this.el.toggleClass(`--state-pending`, !fullfilled);
  }

  handleDataLoadingState(fullfilled) {
    const buttonText = fullfilled ? "Load More" : "Loading...";
    const $btn = jQuery(this.loadMoreButton).find("button.btn-group__chip");
    jQuery(".btn-group__chip-text", $btn).text(buttonText);
    $btn.attr("disabled", !fullfilled);
    this.setDataLoadingStateClasses(fullfilled);
  }

  formatTimes(contentEvents) {
    contentEvents.find('[data-date-format="relative"]').each((i, item) => {
      new RelativeTimeElement(item);
    });
  }

  contrastDetection(contentEvents) {
    contentEvents.find(".content-timeline-entry .event-content-message[data-background-color]").each((i, item) => {
      if (window.contrastDetection(jQuery(item).data("backgroundColor"))) {
        jQuery(item).addClass("event-content-message--dark-text"); // black label
      } else {
        jQuery(item).addClass("event-content-message--light-text"); // white label
      }
    });
  }
}

window.ContentEventsList = ContentEventsList;
